/* eslint-disable react/prop-types */ /* eslint-disable import/prefer-default-export */ /* eslint-disable no-unused-vars */ import React, {
  useState,
  useContext,
  useEffect,
} from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import Filter from './Filter';
import { SuppliersTable } from './SuppliersTable';
import FlashContext from '../../components/contexts/FlashContext';
import api from '../../service/axios/api';
import Loading from '../../components/loading/Loading';

const maskCnpj = (v) => v.replace(/\D/g, '')
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2')
    .slice(0, 18)

const maskCpf = (v) => v.replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .slice(0, 14)

const maskPhone = (v) => v.replace(/\D/g, '')
    .replace(/^(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{4})(\d)/, '$1-$2')
    .slice(0, 14)

const maskMobile = (v) => v.replace(/\D/g, '')
    .replace(/^(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .slice(0, 15)

export default function Suppliers() {
  const { t } = useTranslation();
  const { notifyError, notifySuccess } = useContext(FlashContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [itens, setItens] = useState(10);
  const [chipData, setChipData] = useState([]);

  const [name, setName] = useState('');
  const [contact, setContact] = useState('');
  const [cnpj, setCnpj] = useState('');
  const [cpf, setCpf] = useState('');
  const [phone, setPhone] = useState('');
  const [mobile, setMobile] = useState('');
  const [email, setEmail] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [street, setStreet] = useState('');
  const [number, setNumber] = useState('');
  const [complement, setComplement] = useState('');
  const [district, setDistrict] = useState('');
  const [city, setCity] = useState('');
  const [uf, setUf] = useState('');
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);


  const handleCep = async valor => {
   const cep = valor.replace(/\D/g, '').slice(0, 8)
  const formatted = cep.length > 5 ? cep.replace(/(\d{5})(\d)/, '$1-$2') : cep
  setPostalCode(formatted) 

    if (cep.length === 8) {
      try {
        const response = await axios.get(
          `https://viacep.com.br/ws/${cep}/json/`,
        );

        if (response.data.erro) {
          notifyError(t('suppliers.createDialog.errors.postalCode'));
          return;
        }

        setStreet(response.data.logradouro);
        setDistrict(response.data.bairro);
        setCity(response.data.localidade);
        setUf(response.data.uf);
      } catch (error) {
        notifyError(error.message);
      }
    } else if (cep.length === 0) {
      setStreet('');
      setDistrict('');
      setCity('');
      setUf('');
    }
  };

  const handleCreate = async () => {
    if (name.trim().length === 0) {
      notifyError(t('suppliers.createDialog.errors.name'));
      return;
    }
    //  Colocar isso caso o banco esteja configurado para não permitir valores [null]
    if (contact.trim().length === 0) {
      notifyError('Insira um contato para o fornecedor');
      return;
    }
    
    if (cnpj.trim().length === 0 && cpf.trim().length === 0) {
      notifyError('Insira um CPF ou CNPJ para o fornecedor');
      return;
    }
    setLoadingCreate(true);

    try {
      const res = await api.supplier.create(
        name,
        contact,
        cnpj,
        cpf,
        phone,
        mobile,
        email,
        postalCode,
        street,
        number,
        complement,
        district,
        city,
        uf,
      );
      notifySuccess(res.data.message);
      setName('');
      setContact('');
      setCnpj('');
      setCpf('');
      setPhone('');
      setMobile('');
      setEmail('');
      setPostalCode('');
      setStreet('');
      setNumber('');
      setComplement('');
      setDistrict('');
      setCity('');
      setUf('');
      setOpenDialog(false);
      searchData();
    } catch (error) {
      notifyError(error.message);
    } finally {
      setLoadingCreate(false);
    }
  };

  const searchData = currentChips => {
    setLoading(true);

    const filtersToUse = currentChips || chipData;

    api.supplier
      .getAll(filtersToUse, itens, page + 1)
      .then(res => {
        setTotal(res.data.total);
        setData(res.data.docs);
      })
      .catch(error => {
        console.log(error);
        notifyError(error.message);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    searchData();
  }, [page, itens]);

  return (
    <>
      <Loading open={loading} msg={t('suppliers.loading')} />
      <Grid>
        <Grid
          item
          xs={12}
          sm={12}
          style={{ display: 'flex', justifyContent: 'start' }}
        >
          <h3>{t('suppliers.title')}</h3>
        </Grid>

        <Filter
          setChipData={setChipData}
          chipData={chipData}
          find={searchData}
          setPage={setPage}
          setOpenDialog={setOpenDialog}
        />

        <SuppliersTable
          docs={data}
          page={page}
          setPage={setPage}
          itens={itens}
          setItens={setItens}
          total={total}
          searchData={searchData}
        />
      </Grid>
      <Dialog
        onClose={() => setOpenDialog(false)}
        open={openDialog}
        fullWidth
        maxWidth="sm"
      >
        <Loading
          open={loadingCreate}
          msg={t('suppliers.createDialog.loading')}
        />
        <DialogTitle id="simple-dialog-title">
          {t('suppliers.createDialog.title')}
        </DialogTitle>
        <DialogContent>
          <Grid
            container
            spacing={3}
            style={{
              justifyContent: 'center',
            }}
          >
            <Grid item sm={6} xs={12}>
              <TextField
                fullWidth
                label={t('suppliers.filter.options.name')}
                variant="outlined"
                value={name}
                onChange={e => setName(e.target.value)}
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField
                fullWidth
                label={t('suppliers.filter.options.contact')}
                variant="outlined"
                value={contact}
                onChange={e => setContact(e.target.value)}
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField
                fullWidth
                label={t('suppliers.filter.options.document')}
                variant="outlined"
                value={cnpj}
                onChange={e => setCnpj(maskCnpj(e.target.value))}
                placeholder="00.000.000/0000-00"
                inputProps={{ maxLength: 18 }}
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField
                fullWidth
                label='CPF'
                variant="outlined"
                value={cpf}
                onChange={e => setCpf(maskCpf(e.target.value))}
                placeholder="000.000.000-00"
                inputProps={{ maxLength: 14 }}
              />
            </Grid>
            <Grid item sm={6} xs={12}>
         
              <TextField
                fullWidth
                label={t('suppliers.filter.options.phone')}
                variant="outlined"
                value={phone}
                onChange={e => setPhone(maskPhone(e.target.value))}
                placeholder="(00) 0000-0000"
                inputProps={{ maxLength: 14 }}
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField
                fullWidth
                label={t('suppliers.filter.options.mobile')}
                variant="outlined"
                value={mobile}
                onChange={e => setMobile(maskMobile(e.target.value))}
                placeholder="(00) 00000-0000"
                inputProps={{ maxLength: 15 }}
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField
                fullWidth
                label={t('suppliers.filter.options.email')}
                variant="outlined"
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </Grid>
            <Grid item sm={6} xs={12}>
           <TextField
              fullWidth
              label={t('suppliers.filter.options.postalCode')}
              variant="outlined"
              value={postalCode}
              onChange={e => handleCep(e.target.value)}
              placeholder="00000-000"
              inputProps={{ maxLength: 9 }}
            />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField
                fullWidth
                label={t('suppliers.filter.options.street')}
                variant="outlined"
                value={street}
                disabled
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField
                fullWidth
                label={t('suppliers.filter.options.number')}
                variant="outlined"
                value={number}
                onChange={e => setNumber(e.target.value)}
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField
                fullWidth
                label={t('suppliers.filter.options.complement')}
                variant="outlined"
                value={complement}
                onChange={e => setComplement(e.target.value)}
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField
                fullWidth
                label={t('suppliers.filter.options.district')}
                variant="outlined"
                value={district}
                disabled
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField
                fullWidth
                label={t('suppliers.filter.options.city')}
                variant="outlined"
                value={city}
                disabled
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TextField
                fullWidth
                label={t('suppliers.filter.options.state')}
                variant="outlined"
                value={uf}
                disabled
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            style={{ height: 40 }}
            onClick={() => setOpenDialog(false)}
            variant="text"
            color="primary"
          >
            {t('suppliers.createDialog.buttons.cancel')}
          </Button>
          <Button
            style={{ height: 40 }}
            onClick={handleCreate}
            variant="contained"
            color="primary"
          >
            {t('suppliers.createDialog.buttons.create')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
